import React, { useEffect, useState, useRef } from "react";
import googleImg from "../static/img/google.png";
import UserService from "../../../class/User/UserService";
import UserServices from "../../../class/User_copy/UserService";
// import { useWebSocket } from '../../../context/WebSocketContext';


import AuthService from "../../../class/services/AuthService";

import ModalForgot from "./modal_forgot";

import { useTranslation } from "react-i18next";

function ModalLogin({
    show,
    onClose,
    setIsLogged,
    setUserId,
    onOpenRegisterModal,
    setIsUserCashBlocked,
    setHomeReload,
    triggerLinkLogin,
    setTriggerLinkLogin,
}) {
    const modalRef = useRef();

    const { t } = useTranslation();

    const [animate, setAnimate] = useState(false);
    const [visible, setVisible] = useState(show);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [twoFactorRequired, setTwoFactorRequired] = useState(false);
    const [twoFactorCode, setTwoFactorCode] = useState("");
    const [userId, setUserIdLocal] = useState(null);
    const [block, setBlock] = useState("block");

    // const { connectWebSocket } = useWebSocket();

    const handleOpenModal = () => {
        modalRef.current.open();
        setBlock("none");
    };

    useEffect(() => {
        if (show) {
            setVisible(true);
            setTimeout(() => setAnimate(true), 200);
        } else {
            setAnimate(false);
            setTimeout(() => setVisible(false), 300);
        }
    }, [show]);

    useEffect(() => {
        if (triggerLinkLogin) {
            handleLinkLoginLogin();
        }
    }, [triggerLinkLogin]);

    if (!visible) return null;

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await UserServices.login(email, password);
            // console.log("Login successful:", response);
            // return false;
            // if (response.status == "ok") {
            //   // ⬇️ 1. Если сервер прислал redirect_url — сразу уходим по нему
            //   if (user.redirect_url) {
            //     // Для React Router 6 можно сделать navigate(response.redirect_url);
            //     // но самый универсальный способ — через window.location:
            //     window.location.href = response.redirect_url;
            //     return; // прерываем дальнейшее выполнение
            //   }
            // }

            if (response.status == "ok") {
                const user = response.params.user;
                // console.log("user");
                // console.log(user);

                // if (response.twofa == 1) {

                //   setTwoFactorRequired(true);
                //   setUserIdLocal(response.user_id);
                // } else {

                if (user.cashblocked && user.cashblocked == 1) {
                    AuthService.setCustom("user_cash_block", true);

                    // setIsUserCashBlocked(true);
                }


                finalizeLogin(user);
                //connectWebSocket();

                // }
            } else {
                setError(response.message || t("Login_failed"));
            }
        } catch (error) {
            setError(t("An_error_occurred._Please_try_again."));
            console.error(error);
        }
    };

    const handleLinkLoginLogin = async () => {
        setError("");

        try {
            const response = await UserServices.linkLogin(
                AuthService.getCustom("user_hash"),
            );
            if (response.status == "ok") {
                const user = response.params.user;
                // console.log(response);
                if (user.cashblocked && user.cashblocked == 1) {
                    AuthService.setCustom("user_cash_block", true);
                }

                finalizeLogin(user);
                //connectWebSocket();

            } else {
                setError(response.message || t("Login_failed"));
            }
        } catch (error) {
            setError(t("An_error_occurred._Please_try_again."));
            console.error(error);
        } finally {
            setTriggerLinkLogin(false);
        }
    };

    const handleVerify2FA = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await UserService.verifycode2fa_skin(
                userId,
                twoFactorCode,
            );
            if (response.status) {
                finalizeLogin(response);
                //connectWebSocket();

                if (response.cash_blocked == 1) {
                    AuthService.setCustom("user_cash_block", true);

                    // setIsUserCashBlocked(true);
                }
            } else {
                setError(t("Invalid_2FA_code._Try_again."));
            }
        } catch (error) {
            setError(t("An_error_occurred._Please_try_again."));
            console.error(error);
        }
    };

    const finalizeLogin = (response) => {
        AuthService.setToken(response.user_auth_token);
        AuthService.setCustom("username", response.username);
        AuthService.setCustom("user_id", response.user_auth_token);
        AuthService.setCustom("skin_token", response.id); //skin_token
        AuthService.setCustom("skin_order", response.skin_id); //skin_order
        AuthService.setCustom("currency", response.currency);
        // AuthService.setCustom("api_key", response.api_key);
        setIsLogged(true);
        setHomeReload(true);
        onClose();
    };

    return (
        <>
            <div
                className={`modal fade login_modal ${animate ? "show" : ""}`}
                style={{ display: block }}
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>{t("Login")}</h3>
                            <button
                                className="btn-close"
                                onClick={onClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            {error && (
                                <div className="alert alert-danger">
                                    {error}
                                </div>
                            )}
                            <section className="forms">
                                <div className="form login">
                                    <div className="form-content">
                                        {!twoFactorRequired ? (
                                            <form onSubmit={handleLogin}>
                                                <div className="field input-field">
                                                    <input
                                                        type="text"
                                                        placeholder={t(
                                                            "Username",
                                                        )}
                                                        className="input"
                                                        value={email}
                                                        onChange={(e) =>
                                                            setEmail(
                                                                e.target.value,
                                                            )
                                                        }
                                                        required
                                                    />
                                                </div>
                                                <div className="field input-field">
                                                    <input
                                                        type={
                                                            showPassword
                                                                ? "text"
                                                                : "password"
                                                        }
                                                        placeholder={t(
                                                            "Password",
                                                        )}
                                                        className="password"
                                                        value={password}
                                                        onChange={(e) =>
                                                            setPassword(
                                                                e.target.value,
                                                            )
                                                        }
                                                        required
                                                    />

                                                    <i
                                                        className={`bx ${showPassword ? "bx-show" : "bx-hide"} eye-icon`}
                                                        onClick={() =>
                                                            setShowPassword(
                                                                !showPassword,
                                                            )
                                                        }
                                                    ></i>
                                                </div>
                                                {/* <div class="form-link">
                              <a onClick={handleOpenModal} class="forgot-pass">Forgot password?</a>
                          </div> */}
                                                <div className="field button-field">
                                                    <button type="submit">
                                                        {t("Login")}
                                                    </button>
                                                </div>
                                            </form>
                                        ) : (
                                            <form onSubmit={handleVerify2FA}>
                                                <div className="form-link">
                                                    <a className="forgot-pass">
                                                        {t(
                                                            "Enter_the_six_digit_code",
                                                        )}
                                                    </a>
                                                </div>
                                                <div className="field input-field two-factor">
                                                    <input
                                                        type="number"
                                                        placeholder="-"
                                                        min="0"
                                                        max="999999"
                                                        className="input"
                                                        value={twoFactorCode}
                                                        onChange={(e) =>
                                                            setTwoFactorCode(
                                                                e.target.value,
                                                            )
                                                        }
                                                        required
                                                    />
                                                </div>
                                                <div className="field button-field">
                                                    <button type="submit">
                                                        {t("Verify")}
                                                    </button>
                                                </div>
                                            </form>
                                        )}
                                        {/*  <div className="form-link">
                      <span>
                      {t('Don_t_have_an_account')}{' '}
                      <a
                          href="#"
                          className="link signup-link"
                          onClick={(e) => {
                            e.preventDefault();   
                            onClose();            
                            setTimeout(onOpenRegisterModal, 300); 
                          }}
                        >
                          {t('Sign_up')}
                        </a>

                      </span>
                    </div> */}
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>

            <ModalForgot ref={modalRef} setBlock={setBlock} />

            {visible && (
                <div
                    className={`modal-backdrop fade ${animate ? "show" : ""}`}
                    onClick={onClose}
                ></div>
            )}
        </>
    );
}

export default ModalLogin;
